import React from 'react';

import { Route, Switch, Redirect } from 'react-router-dom';
import styled from 'styled-components';

import { GOOGLE_RMF, ENABLE_API_CONNECTIONS_PAGE, useFeatureFlag } from 'lib/configcat';

import { PlatformsSettings } from './PlatformsSettingsPage';
import { V2Route } from '../../../../V2Route';
import Box from '../../../common/Box';
import { MenuItem } from '../../../layout/MenuItem';
import { SubMenu } from '../../../layout/SubMenu';
import { AdsProviderAccounts } from '../common/AdsProviderAccounts';
import { BiddingStrategyMetrics } from '../GoogleRMF/BiddingStrategyMetrics';
import { CalloutExtensions } from '../GoogleRMF/CalloutExtensionsPage';

const Style = styled.div`
  background: #f2f2f2;
  min-height: 100%;
`;

const StyledBox = styled(Box).withConfig({
  displayName: 'StyledBox',
})`
  margin: 1.5em 1em -1em 1em;
  padding: 1rem 2rem;
`;

export function AdsProviderSettingsPage({ match, account }) {
  const [showCalloutExtensions] = useFeatureFlag(GOOGLE_RMF);

  return (
    <>
      <Style>
        <StyledBox>
          <SubMenu>
            <MenuItem label="Accounts" to={`${match.url}/accounts`} />
            <MenuItem label="Platforms" to={`${match.url}/platforms`} />
            {showCalloutExtensions && (
              <>
                <MenuItem label="Google Ads Callout Extensions" to={`${match.url}/callouts`} />
                <MenuItem label="Bidding Strategy Metrics" to={`${match.url}/biddingmetrics`} />
              </>
            )}
          </SubMenu>
        </StyledBox>

        <Switch>
          <V2Route
            flag={ENABLE_API_CONNECTIONS_PAGE}
            path={`${match.url}/accounts`}
            v2Path={`/v2/settings/api-connections?wsId=${account.id}`}
            render={() => <AdsProviderAccounts account={account} />}
          />
          <Route path={`${match.url}/platforms`} render={() => <PlatformsSettings account={account} />} />

          {showCalloutExtensions && (
            <>
              <Route path={`${match.url}/callouts`} render={() => <CalloutExtensions />} />
              <Route path={`${match.url}/biddingmetrics`} render={() => <BiddingStrategyMetrics />} />
            </>
          )}

          <Redirect to={`${match.url}/accounts`} />
        </Switch>
      </Style>
    </>
  );
}
